import { Modal } from "react-bootstrap";
import { useState } from "react";
import { CustomInput, ReactSelect } from "../kits/Inputs/Inputs";
import CustomButton from "../kits/button/CustomButton";
import useAxios from "../../services/useAxios";
import ToastCustomize from "../kits/ToastCustomize";
import "./CustomerList.scss";
import DatePiker from "../datepiker/datePiker";
// import { title } from "process";
export default function ModalFilter({
  show,
  setShow,
  tagOption,
  content,
  setContent,
  customerUpdater,
  setCustomerUpdater,
}) {
  console.log("mmm", tagOption);
  const { execute: filterCustomer } = useAxios("api2/get_customers");
  const [Labels, setTLabelsype] = useState([
    { value: "0", label: "حقیقی  " },
    { value: "1", label: "حقوقی  " },
  ]);
  // const [customerUpdater, setCustomerUpdater] = useState(false);

  const [filterData, setFilterData] = useState({
    fname: "",
    lname: "",
    companiName: "",
    mtmfrom: "",
    mtmto: "",
    firstFactorFrom: "",
    firstFactorTo: "",
    countTo: "",
    countFrom: "",
    spaceFrom: "",
    spaceTo: "",
    mobile: "",
    hashtagId: [],
  });
  console.log(filterData, "filterData");
  console.log(filterData.hashtagId, "hashtagId");

  const [selectedLable, setSelectedLable] = useState([]);
  const changeHandler = (value, type) => {
    console.log("va", value);
    setFilterData((prev) => {
      return { ...prev, [type]: value };
    });
  };
  // filter customer
  async function filterCustomerFun(
    firstname,
    lastname,
    company_name,
    mtm_customer,
    firstFactorTm,
    purchase_count,
    purchase_volume,
    mobile,
    tags
  ) {
    console.log(mtm_customer, "mtm_customer");

    await filterCustomer({
      ...(firstname != "" && { firstname }),
      ...(lastname != "" && { lastname }),
      ...(company_name != "" && { company_name }),
      ...(mtm_customer != "undefined,undefined" && { mtm_customer }),
      ...(firstFactorTm != "undefined,undefined" && { firstFactorTm }),
      ...(purchase_count != "," && { purchase_count }),
      ...(purchase_volume != "," && {
        purchase_volume,
      }),
      ...(mobile != "" && { mobile }),
      ...(tags != "" && { tags }),
    }).then((res) => {
      if (res.total > 0) {
        setContent(res.customers);
        setShow(false);

        // setCustomerUpdater((prev) => !prev);
      } else if (res.total <= 0) {
        ToastCustomize({
          mainText: " ایتم پیدا نشد         ",
          duration: 4000,
          toastType: "danger",
          color: "danger",
          position: "top-center",
          hasHeader: false,
        });
      } else {
        ToastCustomize({
          mainText: " مشکلی در انجام عملیات پیش آمده است   ",
          duration: 4000,
          toastType: "danger",
          color: "danger",
          position: "top-center",
          hasHeader: false,
        });
      }
    });
  }
  // const valid = (

  // ) => {
  //   if (
  //     filterData.fname == "" &&
  //     filterData.lname == "" &&
  //     filterData.companiName == "" &&
  //     filterData.mtmfrom == "" &&
  //     filterData.mtmto == "" &&
  //     filterData.countFrom == "" &&
  //     filterData.countTo == "" &&
  //     filterData.spaceFrom == "" &&
  //     filterData.spaceTo == "" &&
  //     filterData.mobile == "" &&
  //     filterData.firstFactorFrom == "" &&
  //     filterData.firstFactorTo == "" &&
  //     filterData.hashtagId == ""
  //   ) {
  //     ToastCustomize({
  //       mainText: " حداقل یکی از ایتم ها را وارد کنید           ",
  //       duration: 4000,
  //       toastType: "danger",
  //       color: "danger",
  //       position: "top-center",
  //       hasHeader: false,
  //     });
  //   } else if (
  //     filterData.fname ||
  //     filterData.lname ||
  //     filterData.companiName ||
  //     filterData.mtmfrom ||
  //     filterData.mtmto ||
  //     filterData.countFrom ||
  //     filterData.countTo ||
  //     filterData.spaceFrom ||
  //     filterData.spaceTo ||
  //     filterData.mobile ||
  //     filterData.firstFactorFrom ||
  //     filterData.firstFactorTo ||
  //     filterData.hashtagId
  //   ) {
  //     filterCustomerFun(

  //     );
  //   }
  // };
  return (
    <>
      <Modal
        size="lg"
        show={show}
        onHide={() => setShow(false)}
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-custom-modal-styling-title">
            فیلتر لیست مشتریان
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="p-modalfilter">
            <div className="row m-1 box-row">
              <div className="col-4  box-lab">
                <label htmlFor="titleTour" className="form-label">
                  نام:
                </label>
              </div>
              <div className="col-12 col-sm-8">
                <CustomInput
                  id="titleTour"
                  inputSize="lg"
                  type="text"
                  inputContainer=""
                  inputValue={filterData.fname}
                  onChangeFunc={(e) => changeHandler(e.target.value, "fname")}
                  // textErr={validationTxt.title}
                />
              </div>
            </div>
            <div className="row m-1 box-row">
              <div className="col-4  box-lab">
                <label htmlFor="titleTour" className="form-label">
                  نام خوانوادگی:
                </label>
              </div>
              <div className="col-12 col-sm-8">
                <CustomInput
                  id="titleTour"
                  inputSize="lg"
                  type="text"
                  inputContainer=""
                  inputValue={filterData.lname}
                  onChangeFunc={(e) => changeHandler(e.target.value, "lname")}
                  // textErr={validationTxt.title}
                />
              </div>
            </div>
            <div className="row m-1 box-row">
              <div className="col-4  box-lab">
                <label htmlFor="titleTour" className="form-label">
                  نام شرکت:
                </label>
              </div>
              <div className="col-12 col-sm-8">
                <CustomInput
                  id="titleTour"
                  inputSize="lg"
                  type="text"
                  inputContainer=""
                  inputValue={filterData.companiName}
                  onChangeFunc={(e) =>
                    changeHandler(e.target.value, "companiName")
                  }
                  // textErr={validationTxt.title}
                />
              </div>
            </div>
            <div className="row m-1 mt-3 box-row">
              <div className="col-4  box-lab">
                <label htmlFor="mtmFor" className="form-label">
                  تاریخ ثبت از :
                </label>
              </div>
              <div className="col-12 col-sm-8">
                <div className="d-flex">
                  <DatePiker
                    inputSize="text"
                    value={filterData.mtmfrom}
                    setValue={(e) => {
                      changeHandler(e, "mtmfrom");
                    }}
                  ></DatePiker>

                  <p className=" px-2 m-auto">تا </p>
                  <DatePiker
                    inputSize="text"
                    value={filterData.mtmto}
                    setValue={(e) => {
                      console.log("ee", e);
                      changeHandler(e, "mtmto");
                    }}
                  ></DatePiker>
                  {/* <CustomInput
                    id="mtmTo"
                    inputSize="lg"
                    type="text"
                    inputContainer=""
                    inputValue={filterData.mtmto}
                    onChangeFunc={(e) => changeHandler(e.target.value, "mtmto")}
                  /> */}
                </div>
              </div>
            </div>
            <div className="row m-1 mt-3 box-row">
              <div className="col-4  box-lab">
                <label
                  htmlFor="dateFactorFor"
                  className="form-label"
                  style={{ whiteSpace: "nowrap" }}
                >
                  تاریخ اولین فاکتور از :
                </label>
              </div>
              <div className="col-12 col-sm-8">
                <div className="d-flex">
                  <DatePiker
                    inputSize="text"
                    value={filterData.firstFactorFrom}
                    setValue={(e) => {
                      console.log("ee", e);
                      changeHandler(e, "firstFactorFrom");
                    }}
                  ></DatePiker>
                  {/* <CustomInput
                    id="dateFactorFor"
                    name="complate_order_count_from"
                    inputSize="lg"
                    type="text"
                    inputContainer=""
                    inputValue={filterData.firstFactorFrom}
                    onChangeFunc={(e) =>
                      changeHandler(e.target.value, "firstFactorFrom")
                    }
                  /> */}
                  <p className=" px-2 m-auto">تا </p>
                  <DatePiker
                    inputSize="text"
                    value={filterData.firstFactorTo}
                    setValue={(e) => {
                      console.log("ee", e);
                      changeHandler(e, "firstFactorTo");
                    }}
                  ></DatePiker>
                  {/* <CustomInput
                    id="dateFactorTo"
                    name="complate_order_count_to"
                    inputSize="lg"
                    type="text"
                    inputContainer=""
                    inputValue={filterData.firstFactorTo}
                    onChangeFunc={(e) =>
                      changeHandler(e.target.value, "firstFactorTo")
                    }
                  /> */}
                </div>
              </div>
            </div>
            <div className="row m-1 mt-3 box-row">
              <div className="col-4  box-lab">
                <label htmlFor="countSaleFrom" className="form-label">
                  تعداد خریداز :
                </label>
              </div>
              <div className="col-12 col-sm-8">
                <div className="d-flex">
                  <CustomInput
                    id="countSaleFrom"
                    inputSize="lg"
                    type="text"
                    inputContainer=""
                    inputValue={filterData.countFrom}
                    onChangeFunc={(e) =>
                      changeHandler(e.target.value, "countFrom")
                    }
                  />
                  <p className=" px-2 m-auto">تا </p>

                  <CustomInput
                    id="countSaleTo"
                    inputSize="lg"
                    type="text"
                    inputContainer=""
                    inputValue={filterData.countTo}
                    onChangeFunc={(e) =>
                      changeHandler(e.target.value, "countTo")
                    }
                  />
                </div>
              </div>
            </div>
            <div className="row m-1 mt-3 box-row">
              <div className="col-4  box-lab">
                <label htmlFor="spaceSaleFrom" className="form-label">
                  حجم خریداز :
                </label>
              </div>
              <div className="col-12 col-sm-8">
                <div className="d-flex">
                  <CustomInput
                    id="spaceSaleFrom"
                    inputSize="lg"
                    type="text"
                    inputContainer=""
                    inputValue={filterData.spaceFrom}
                    onChangeFunc={(e) =>
                      changeHandler(e.target.value, "spaceFrom")
                    }
                  />
                  <p className=" px-2 m-auto">تا </p>

                  <CustomInput
                    id="spaceSaleTo"
                    inputSize="lg"
                    type="text"
                    inputContainer=""
                    inputValue={filterData.spaceTo}
                    onChangeFunc={(e) =>
                      changeHandler(e.target.value, "spaceTo")
                    }
                  />
                </div>
              </div>
            </div>
            <div className="row m-1  mt-3 box-row">
              <div className="col-4  box-lab">
                <label htmlFor="tel" className="form-label">
                  شماره تماس:
                </label>
              </div>
              <div className="col-12 col-sm-8">
                <CustomInput
                  id="tel"
                  inputSize="lg"
                  type="text"
                  inputContainer=""
                  inputValue={filterData.mobile}
                  onChangeFunc={(e) => changeHandler(e.target.value, "mobile")}
                />
              </div>
            </div>
            <div className="row m-1 mt-3 box-row">
              <div className="col-4 box-lab">
                <label htmlFor="lable" className="form-label">
                  برچسب ها:
                </label>
              </div>
              <div className="col-12 col-sm-8" style={{ marginTop: "-14px" }}>
                <ReactSelect
                  itemsList={tagOption}
                  inputContainer=""
                  inputSize="lg"
                  isMulti={true}
                  inputValue={filterData.hashtagId}
                  onChangeFunc={(e, action) => {
                    changeHandler(
                      e,
                      "hashtagId"
                      // action.option.value
                    );
                  }}
                  // itemsList={tagOption}
                  // inputContainer=""
                  // inputSize="lg"
                  // isMulti={true}
                  // inputValue={filterData.hashtagId}
                  // onChangeFunc={(e) =>
                  //   setFilterData((prev) => {
                  //     return { ...prev, hashtagId: e };
                  //   })
                  // }
                />
              </div>
            </div>
            <div className="d-flex justify-content-end mt-4">
              <div>
                {" "}
                <CustomButton
                  color="red"
                  size="large"
                  state="normal"
                  // type="outline"
                  circle={false}
                  onClick={(e) => {
                    filterCustomerFun(
                      filterData.fname,
                      filterData.lname,
                      filterData.companiName,

                      `${
                        filterData.mtmfrom == "" && filterData.mtmto != ""
                          ? filterData.mtmto.unix - 24 * 60 * 60
                          : filterData.mtmfrom.unix
                      },${
                        filterData.mtmto == "" && filterData.mtmfrom != ""
                          ? filterData.mtmfrom.unix + 24 * 60 * 60
                          : filterData.mtmto.unix
                      }`,
                      // `${filterData.firstFactorFrom.unix},${filterData.firstFactorTo.unix}`,
                      `${
                        filterData.firstFactorFrom == "" &&
                        filterData.firstFactorTo != ""
                          ? filterData.firstFactorTo.unix - 24 * 60 * 60
                          : filterData.firstFactorFrom.unix
                      },${
                        filterData.firstFactorTo == "" &&
                        filterData.firstFactorFrom != ""
                          ? filterData.firstFactorFrom.unix + 24 * 60 * 60
                          : filterData.firstFactorTo.unix
                      }`,

                      `${filterData.countFrom},${filterData.countTo}`,
                      `${filterData.spaceFrom},${filterData.spaceTo}`,
                      filterData.mobile,

                      filterData?.hashtagId
                        ?.map((val, ind) => {
                          return val.value;
                        })
                        .toString()
                    );
                  }}
                >
                  فیلتر
                </CustomButton>
              </div>
              <div className="mx-3">
                <CustomButton
                  color="warning"
                  size="large"
                  state="normal"
                  // type="outline"
                  circle={false}
                  onClick={(e) => {
                    setCustomerUpdater((prev) => !prev);

                    setFilterData({
                      fname: "",
                      lname: "",
                      companiName: "",
                      mtmfrom: "",
                      mtmto: "",
                      firstFactorFrom: "",
                      firstFactorTo: "",
                      countTo: "",
                      countFrom: "",
                      spaceFrom: "",
                      spaceTo: "",
                      mobile: "",
                      hashtagId: [],
                    });
                  }}
                >
                  حذف فیلتر
                </CustomButton>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
